import * as Sentry from '@sentry/react'
import { appSettings } from '@/shared/consts/appSettings'
import { getZustandStoresSnapshot } from '@/store/zustandStores'
import { getDeviceId, getSessionId } from '@/utils/helpers/storageHelpers'
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes
} from 'react-router'
import React from 'react'

Sentry.init({
  dsn: appSettings.sentryDSN,
  release: appSettings.applicationVersion,
  enabled: appSettings.environment === 'production',
  sampleRate: 1,
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.7,
  debug: false,
  beforeSend(event) {
    const zustandState = getZustandStoresSnapshot()
    event.contexts = {
      ...event.contexts,
      zustand: zustandState
    }
    event.tags = {
      ...event.tags,
      deviceId: getDeviceId(),
      sessionId: getSessionId()
    }
    return event
  },
  enableLogs: true,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    }),
    Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
    Sentry.replayIntegration({
      networkDetailAllowUrls: [/.*/],
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false
    })
  ]
})
